import "devextreme/dist/css/dx.light.css";

import DevExPivotGrid, {
  Export,
  FieldChooser,
} from "devextreme-react/pivot-grid";
import { useCallback, useEffect, useState } from "react";

import Controls from "./Controls.js";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import { Workbook } from "exceljs";
import dayjs from "dayjs";
import { exportPivotGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import useLocale from "../../hooks/useLocale.js";

const PivotGrid = ({ data, isLoading }) => {
  const [showColumnTotals, setShowColumnTotals] = useState(false);
  const [showColumnGrandTotals, setShowColumnGrandTotals] = useState(true);
  const [showRowGrandTotals, setShowRowGrandTotals] = useState(true);
  const { t } = useLocale();

  const onExporting = useCallback((e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(
      `statistics-${dayjs().format("YYYY-MM-DD")}`
    );

    exportPivotGrid({
      component: e.component,
      worksheet,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Sales.xlsx"
        );
      });
    });
    e.cancel = true;
  });

  let texts = {
    grandTotal: t("Grand total"),
  };

  let dataSource = new PivotGridDataSource({
    fields: fields,
    store: data,
  });

  return (
    <>
      {false && (
        <Controls
          showColumnTotals={showColumnTotals}
          showColumnGrandTotals={showColumnGrandTotals}
          showRowGrandTotals={showRowGrandTotals}
          setShowColumnTotals={setShowColumnTotals}
          setShowColumnGrandTotals={setShowColumnGrandTotals}
          setShowRowGrandTotals={setShowRowGrandTotals}
        />
      )}
      <DevExPivotGrid
        id="pivotgrid"
        loadPanel={{ enabled: true, showPane: true }}
        dataSource={dataSource}
        allowSortingBySummary={true}
        allowFiltering={true}
        showBorders={true}
        showColumnTotals={showColumnTotals}
        showColumnGrandTotals={showColumnGrandTotals}
        showRowTotals={false}
        texts={texts}
        hideEmptySummaryCells={false}
        showRowGrandTotals={showRowGrandTotals}
        onExporting={onExporting}
      >
        <FieldChooser enabled={true} height={400} />
        <Export enabled={true} />
      </DevExPivotGrid>
    </>
  );
};

export default PivotGrid;

const fields = [
  {
    dataField: "sector",
    caption: "Sector",
    width: 120,
    area: "row",
  },
  {
    dataField: "appl_kind",
    area: "column",
    expanded: true,
  },
  {
    dataField: "document_color",
    area: "column",
  },
  {
    // dataField: "appl_dt",
    // dataType: "date",
    // area: "column",
  },
  {
    caption: "Total",
    dataField: "count",
    dataType: "count",
    summaryType: "sum",
    area: "data",
  },
];
